var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quantidadeProdutos > 0)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({class:_vm.iconClass,attrs:{"color":"primary","small":_vm.small}},on),[_vm._v(" mdi-shield-check ")])]}}],null,false,957042987)},[_c('span',[_vm._v(_vm._s(_vm.tooltipIsHomologado))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }